<template>
    <div>
        <el-steps :active="active" finish-status="success" align-center>
            <el-step title="Paso 1" description="Evaluación de nivel"></el-step>
            <el-step title="Paso 2" description="Formulario de reserva"></el-step>
        </el-steps>
    </div>
</template>

<script>
    export default {
        props: ['active'],
    }
</script>
